// extracted by mini-css-extract-plugin
export var resizableArea = "resizable-area-module--resizableArea--2UXH8";